__turbopack_context__.v({
  "action": "_5Kl-YW_action",
  "danger": "_5Kl-YW_danger",
  "icon": "_5Kl-YW_icon",
  "iconClose": "_5Kl-YW_iconClose",
  "info": "_5Kl-YW_info",
  "messageContent": "_5Kl-YW_messageContent",
  "p": "_5Kl-YW_p",
  "snackbar": "_5Kl-YW_snackbar",
  "success": "_5Kl-YW_success",
  "warning": "_5Kl-YW_warning",
});
